import { Schemas } from 'src/openapi/generated/types';
import { ReservationFlowInvalidRequestError } from 'src/interfaces/reservation_flow';

export const filterReservationFlowInvalidRequestDetails: (
  details: ReservationFlowInvalidRequestError['details'],
) => Schemas.ReservationFlowInvalidRequest[] = (details) => {
  return details.filter((detail) => {
    return detail.type === 'reservation_flow_invalid_request';
  }) as Schemas.ReservationFlowInvalidRequest[];
};
